import React from "react";

export default function HamburgerIcon({ isOpen }) {
  return (
    <div className="flex flex-col justify-center items-end w-8 h-8 cursor-pointer relative">
      <span
        className={`absolute top-1 left-0 h-[2px] rounded transition-all duration-300 ease-in-out ${
          isOpen ? "rotate-45 top-3 w-6" : "w-6"
        }`}
        style={{
          background: "linear-gradient(90deg,rgb(234, 221, 231),rgb(210, 199, 236))",
        }}
      ></span>
      <span
        className={`absolute top-3 left-0 h-[2.5px] rounded transition-all duration-300 ease-in-out ${
          isOpen ? "opacity-0" : "w-4"
        }`}
        style={{
          background: "linear-gradient(90deg,rgb(255, 255, 255),rgb(200, 180, 247))",
        }}
      ></span>
      <span
        className={`absolute top-5 left-0 h-[2px] rounded transition-all duration-300 ease-in-out ${
          isOpen ? "-rotate-45 top-3 w-6" : "w-5"
        }`}
        style={{
          background: "linear-gradient(90deg,rgb(255, 255, 255),rgb(217, 204, 248))",
        }}
      ></span>
    </div>
  );
}
